import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GTMTracking, Modal } from '@common/ui/general';
import {
  successModalSelector,
} from '@alumni_v2/selectors/reviews';
import {
  toggleSuccessModal,
} from '@alumni_v2/stores/reviews/actions';
import { useMediaQuery } from '@common/hooks';

import successIcon from '@alumni_v2/images/svg/tick.svg';
import tickIcon from '@alumni_v2/images/svg/simple-tick.svg';

import styles from './SuccessModal.module.scss';

const SuccessModal = () => {
  const dispatch = useDispatch();

  const { tablet } = useMediaQuery();

  const {
    successModalOpen,
  } = useSelector(successModalSelector) || {};

  const onCloseModal = useCallback(() => {
    dispatch(toggleSuccessModal());
  }, [dispatch]);

  return (
    <>
      <Modal
        isOpen={successModalOpen}
        position={tablet ? 'bottom' : 'center'}
        className={styles.containerUi}
        backdropClassName={styles.backdropUi}
        containerClassName={styles.bodyUi}
        headerClassName={styles.crossHeader}
      >
        <GTMTracking
          component="button"
          gtmEventType="cta"
          gtmEventAction="click"
          gtmEventResult="qna_success_modal_close"
          gtmEventCategory="alumni_directory"
          className={styles.icon}
          onClick={onCloseModal}
          role="button"
          tabIndex={0}
          gtmEventData={{
            click_text: 'close_icon',
            click_type: 'qna_success_modal_close',
            click_section: 'qna_success_details_modal',
          }}
        >
          X
        </GTMTracking>
        <div className={styles.mainContainer}>
          <div className={styles.submittedHeading}>
            <img
              className={styles.successIcon}
              src={successIcon}
              alt="success-icon"
            />
            <div>You have submitted your questions!</div>
          </div>

          <div className={styles.varificationPoints}>
            <div className={styles.iconBox}>
              <img src={tickIcon} alt="tick-icon" />
              <div>
                We will verify your questions and forward to the Alumni
              </div>
            </div>
            <div className={styles.iconBox}>
              <img src={tickIcon} alt="tick-icon" />
              <div>
                You will be notified via Email / Whatsapp
                when the questions are answered
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SuccessModal;
